import {
  BusinessDocumentType,
  DocumentResource,
} from '~domains/partner-application/entities/application';
import { Card } from '~domains/partner-application/shared/ui/card';

import { DocumentReviewItem } from './document-review-item';

const documentTypeToTitle: Record<BusinessDocumentType, string> = {
  BUSINESS_PERMIT: "Business Permit / Mayor's Permit",
  BIR_CERTIFICATE_OR_FORM2303: 'BIR Certificate of Registration or Form 2303',
  DTI_CERTIFICATE: 'DTI Certificate of Business Name Registration',
  OTHER: 'Other',
};

type BusinessDocumentsReviewProps = {
  businessDocuments: DocumentResource[] | undefined;
  onEdit?: () => void;
};

export const BusinessDocumentsReview = ({
  businessDocuments,
  onEdit,
}: BusinessDocumentsReviewProps) => {
  if (!businessDocuments) {
    return null;
  }

  return (
    <Card header="Business documents" onEdit={onEdit}>
      <div className="flex flex-col gap-3">
        {businessDocuments.map((document) => (
          <DocumentReviewItem
            key={document.documentId}
            title={documentTypeToTitle[document.type as BusinessDocumentType]}
            document={document}
          />
        ))}
      </div>
    </Card>
  );
};
